import { render, staticRenderFns } from "./exercisesDetail.vue?vue&type=template&id=5d682640&scoped=true&"
import script from "./exercisesDetail.vue?vue&type=script&lang=js&"
export * from "./exercisesDetail.vue?vue&type=script&lang=js&"
import style0 from "./exercisesDetail.vue?vue&type=style&index=0&id=5d682640&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d682640",
  null
  
)

export default component.exports